
const rows = [
  { label: "Fee per case", highTouch: "£2,500", ai: "£350", combined: "£780 avg" },
  { label: "Case volume", highTouch: "15,192", ai: "60,768", combined: "75,960" },
  { label: "Revenue", highTouch: "£37.98M", ai: "£21.27M", combined: "£59.2M" },
  { label: "Client type", highTouch: "Complex, high-value", ai: "Price-sensitive, long tail", combined: "Full market" },
];

export function DualTierSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          Advisors capture high-value cases.<br />AI agents unlock the long tail
        </h2>
      </div>

      <div className="overflow-x-auto mt-4">
        <table className="w-full border-collapse text-[12px]">
          <thead>
            <tr>
              <th className="py-2 px-4 w-[22%]" />
              <th className="py-2 px-4 text-left text-[11px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-wider bg-[#a5b4fc] text-white rounded-tl-lg w-[26%]">
                High-Touch Advisor-Led
              </th>
              <th className="py-2 px-4 text-left text-[11px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-wider bg-[#818cf8] text-white w-[26%]">
                Automated AI Agent
              </th>
              <th className="py-2 px-4 text-left text-[11px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-wider bg-[#6366f1] text-white rounded-tr-lg w-[26%]">
                Combined = SOM
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.label} className={i < rows.length - 1 ? "border-b border-[var(--color-border)]" : ""}>
                <td className="py-3 px-4 text-[12px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-wider">
                  {r.label}
                </td>
                <td className="py-3 px-4 font-medium">{r.highTouch}</td>
                <td className="py-3 px-4 font-medium">{r.ai}</td>
                <td className="py-3 px-4 font-bold">{r.combined}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] leading-relaxed text-[var(--color-fg-secondary)] font-light">
          The AI tier isn&apos;t a discount — it&apos;s a <strong className="text-[var(--color-fg)] font-medium">new market</strong>.
          80% of UK visa applicants don&apos;t use professional advisors today, largely because of cost. At £350, we reach them for the first time.
        </p>
      </div>
    </div>
  );
}
